export const OPERATOR = 'operator';
export const DRIVER = 'driver';
export const LAB = 'lab';
export const FILLER = 'filler';

import homeIcon1 from './images/home-icon-1.svg';
import homeIcon2 from './images/home-icon-2.svg';
import homeIcon3 from './images/home-icon-3.svg';
import homeIcon4 from './images/home-icon-4.svg';
import homeIcon5 from './images/home-icon-5.svg';
import homeIcon6 from './images/home-icon-6.svg';
import homeIcon7 from './images/home-icon-7.svg';
import homeIcon8 from './images/home-icon-8.svg';
import homeIcon9 from './images/home-icon-9.svg';
import homeIcon10 from './images/home-icon-10.svg';
import homeIcon11 from './images/home-icon-11.svg';
import homeIcon12 from './images/home-icon-12.svg';

import hero1 from './images/hero-1-woman.png';
import hero2 from './images/hero-2.png';
import hero3 from './images/hero-3.png';
import hero4 from './images/hero-4.png';

export type TStory = {
  id: string;
  title: string;
  image: string;
  homeSlideText: string[];
  homeSlideHidden: {
    icon: string;
    text: string;
  }[];
  startText: {
    title: string;
    text: string;
  };
  questions: {
    [key: string]: {
      question: string;
      extra: string;
      answers: {
        answer: string;
        comment: string;
        extra: string;
      }[];
    };
  };
  finalText: string;
};

type TStories = {
  [key: string]: TStory;
};

export const stories: TStories = {
  operator: {
    id: 'operator',
    title: 'Оператор-кассир АЗС',
    image: hero1,
    homeSlideText: [
      'Каждое утро я&#160;с&#160;улыбкой встречаю клиентов за&#160;кассой. Мой день наполнен общением с&#160;людьми и&#160;заботой о&#160;порядке на&#160;АЗС.',
      'Я&#160;работаю за&#160;кассой и&#160;готовлю свежую выпечку, слежу за&#160;чистотой в&#160;зале и&#160;расставляю товары на&#160;полках.',
      'Я&#160;стараюсь помочь каждому клиенту и&#160;знаю, что&#160;моя работа имеет значение, ведь ежедневно я&#160;делаю что-то хорошее для&#160;сотен людей, спешащих по&#160;своим делам.',
    ],
    homeSlideHidden: [
      {
        icon: homeIcon1,
        text: 'Динамичная профессия в&#160;крупной компании',
      },
      {
        icon: homeIcon2,
        text: 'Обучение за&#160;счет компании',
      },
      {
        icon: homeIcon3,
        text: 'Удобный сменный график',
      },
      {
        icon: homeIcon4,
        text: 'Стабильная зарплата и&#160;премии по&#160;результатам работы',
      },
      {
        icon: homeIcon5,
        text: 'Понятные карьерные возможности',
      },
      {
        icon: homeIcon6,
        text: 'Расширенный пакет ДМС',
      },
      {
        icon: homeIcon7,
        text: 'Бонусы для&#160;семьи и&#160;детские новогодние подарки',
      },
      {
        icon: homeIcon8,
        text: 'Современная форма по&#160;сезону',
      },
      {
        icon: homeIcon9,
        text: 'Скидка на&#160;питание на&#160;АЗС',
      },
    ],
    startText: {
      title:
        'Привет! Меня зовут Анна. Я&#160;пришла работать оператором-кассиром на&#160;АЗС, потому что мне нужен <span>стабильный доход.</span>',
      text: 'Уже в&#160;первые месяцы поняла, что сделала правильный выбор: я&#160;люблю общаться с&#160;людьми, наводить порядок, красиво расставлять товары на&#160;полках. Обожаю аромат свежесваренного кофе и&#160;наше уютное кафе <nobr>G-Drive</nobr>!',
    },
    questions: {
      1: {
        question:
          'По&#160;утрам на&#160;АЗС много клиентов&#160;– нужно успеть помочь каждому. Однажды в&#160;зоне кафе я&#160;заметила растерянную девушку, которая никак не&#160;может справиться с&#160;кофейным аппаратом. А&#160;у&#160;меня очередь на&#160;кассе, <span>как&#160;же всё успеть?</span>',
        extra: '',
        answers: [
          {
            answer:
              'позвать сменщицу за&#160;кассу, а&#160;самой пойти помочь девушке',
            comment:
              '<span>Отличное решение!</span> Вдвоем вы&#160;точно успеете всем помочь и&#160;разгрузите&#160;очередь!',
            extra:
              'Когда я&#160;обратилась к&#160;девушке, оказалось, что она&#160;китаянка и&#160;совершенно не&#160;говорит <nobr>по-русски</nobr>. С&#160;помощью языка жестов и&#160;английских фраз, которые я&#160;помнила со&#160;времен школы, мы довольно быстро разобрались, какой кофе ей&#160;нужен, и&#160;девушка, довольная, продолжила путешествие.',
          },
          {
            answer:
              'скорее принять оплату у&#160;всех клиентов и&#160;пойти помочь девушке',
            comment:
              '<span>Неплохо!</span> Но&#160;не&#160;забывайте, что у&#160;вас есть коллеги, готовые прийти на&#160;помощь не&#160;только посетителям, но&#160;и&#160;вам!',
            extra: '',
          },
        ],
      },
      2: {
        question:
          'У&#160;оператора-кассира очень активная работа: и&#160;оплату принять, и&#160;<nobr>хот-дог</nobr> приготовить, и&#160;бензовоз встретить. Но&#160;я&#160;всегда нахожу минутку, чтобы улыбнуться клиенту. От&#160;этого у&#160;всех улучшается настроение! <span>Мои любимые посетители&#160;– это...</span>',
        extra: '',
        answers: [
          {
            answer: 'дети',
            comment:
              '<span>Обожаю наблюдать детский восторг</span> от&#160;игры во&#160;взрослых, когда родители дают малышам карту и&#160;они&#160;сами оплачивают покупку!',
            extra: '',
          },
          {
            answer: 'водители большегрузов',
            comment:
              'Их&#160;веселые байки про&#160;дорогу <span>поднимают настроение</span> на&#160;весь день!',
            extra: '',
          },
        ],
      },
      3: {
        question:
          'Я&#160;пока не&#160;стала победителем, зато несколько раз съездила на&#160;финал и&#160;увидела в&#160;деле профессионалов со&#160;всей России и&#160;стран&#160;СНГ. <span>На&#160;конкурсе мы...</span>',
        extra:
          'Я&#160;работаю оператором-кассиром уже 10&#160;лет и&#160;пока не&#160;планирую становиться управляющей. Мне хорошо на&#160;своем месте, но&#160;я с&#160;удовольствием каждый год участвую в&#160;конкурсе профессионального мастерства: здесь я&#160;чувствую себя частью стабильной и&#160;развивающейся компании.',
        answers: [
          {
            answer: 'соревнуемся, кто лучше делает свою работу',
            comment:
              'На&#160;конкурсе профессионального мастерства мы&#160;можем <span>продемонстрировать свои лучшие навыки:</span> выполняем задания на&#160;сервис, расставляем товар и&#160;даже готовим <nobr>хот-доги</nobr> на&#160;скорость!',
            extra: '',
          },
          {
            answer: 'наблюдаем за&#160;достижениями коллег',
            comment:
              'Конкурс профессионального мастерства «Газпром нефти»&#160;– <span>прекрасный способ и&#160;на&#160;других посмотреть, и&#160;себя показать!</span>',
            extra: '',
          },
        ],
      },
      4: {
        question:
          'Как вы&#160;думаете, какие корпоративные <span>бонусы</span> еще доступны сотрудникам компании?',
        extra:
          'Мне особенно нравится&#160;то, как «Газпром нефть» заботится о&#160;сотрудниках: мы&#160;можем выбрать удобный график и&#160;место работы поближе к&#160;дому. Никогда не&#160;возникает проблемы&#160;– что надеть, потому что нам предоставляют современную и&#160;удобную форму, а&#160;недавно еще&#160;сделали скидку на&#160;всю продукцию наших кафе.',
        answers: [
          {
            answer: 'ДМС со&#160;стоматологией',
            comment:
              'Возможность обслуживаться в&#160;лучших клиниках за&#160;счет компании, ДМС с&#160;широкой линейкой дополнительных услуг, в&#160;том числе и&#160;стоматологией, предоставляются сотрудникам сразу после трудоустройства.',
            extra: '',
          },
          {
            answer: 'семейные бонусы',
            comment:
              'Подарки на&#160;Новый год, компенсация путевки в&#160;детский оздоровительный лагерь, материальная помощь в&#160;связи с&#160;рождением ребенка: эти и&#160;другие бонусы для&#160;семьи уже доступны для&#160;всех сотрудников «Газпром нефти»!',
            extra: '',
          },
          {
            answer: 'мобильные медицинские обследования',
            comment:
              '«Газпром нефть» комплексно подходит к&#160;заботе о&#160;здоровье сотрудников: в&#160;компании регулярно проводятся медицинские обследования и&#160;углубленные чекапы, а&#160;социальный пакет работников включает обязательную страховку от&#160;несчастных случаев и&#160;болезней.',
            extra: '',
          },
          {
            answer: 'корпоративные мероприятия',
            comment:
              'В&#160;компании проводится множество мероприятий: от&#160;корпоративных конкурсов и&#160;сезонных праздников до&#160;спортивных состязаний и&#160;тематических акций. За&#160;победу в&#160;мотивационных программах коллеги получают ценные подарки: корпоративный мерч или&#160;поездки по&#160;популярным туристическим маршрутам.',
            extra: '',
          },
        ],
      },
      5: {
        question:
          'Мне нравится, что, работая на&#160;АЗС, я&#160;много взаимодействую с&#160;людьми. Я&#160;стала более открытой и&#160;общительной, здесь я&#160;чувствую себя на&#160;своем месте. И&#160;хотя разные ситуации случаются, хорошего, несомненно, больше. <span>Благодаря моей работе я...</span>',
        extra: '',
        answers: [
          {
            answer: 'вышла замуж',
            comment:
              '<span>Я&#160;действительно встретила здесь свою половинку!</span> Один из&#160;постоянных клиентов АЗС часто приезжал в&#160;мою смену заправиться, улыбался, шутил. <nobr>Как-то</nobr> вечером выхожу со&#160;смены, а&#160;он&#160;ждет меня с&#160;букетом! Конечно&#160;же, в&#160;день свадьбы мы&#160;заехали на&#160;родную АЗС.',
            extra: '',
          },
          {
            answer: 'нашла новых друзей',
            comment:
              'У&#160;нас много постоянных клиентов, которые приезжают уже не&#160;только заправиться, но&#160;и&#160;поболтать. Благодаря работе мой круг общения очень расширился. <span>Я&#160;знаю, что здесь меня ждет команда и&#160;друзья</span>, а&#160;значит работа точно будет в&#160;радость.',
            extra: '',
          },
        ],
      },
    },
    finalText:
      '<span>А&#160;вы&#160;бы&#160;хотели работать в&#160;«Газпром нефти»?</span>',
  },
  driver: {
    id: 'driver',
    title: 'Водитель бензовоза',
    image: hero2,
    homeSlideText: [
      'Я&#160;– водитель бензовоза и&#160;немного путешественник. У&#160;меня на&#160;счету тысячи километров за&#160;рулем, и&#160;эта&#160;работа всегда в&#160;радость.',
      ' Я&#160;знаю, что в&#160;пути самое главное&#160;– безопасность. Компания заботится, чтобы я&#160;работал на&#160;современном бензовозе и&#160;перевозил опасный груз безопасно, а&#160;я&#160;в&#160;ответ четко выполняю свою работу.',
      'Благодаря мне и&#160;команде диспетчеров, инженеров, электрослесарей и&#160;логистов топливо вовремя поступает на&#160;АЗС.',
    ],
    homeSlideHidden: [
      {
        icon: homeIcon1,
        text: 'Востребованная работа в&#160;стабильной компании',
      },
      {
        icon: homeIcon6,
        text: 'Расширенный пакет ДМС',
      },
      {
        icon: homeIcon10,
        text: 'Горячее питание для&#160;сотрудников',
      },
      {
        icon: homeIcon3,
        text: 'Удобный гибкий график',
      },
      {
        icon: homeIcon4,
        text: 'Стабильная зарплата и&#160;премии по&#160;результатам работы',
      },
      {
        icon: homeIcon11,
        text: 'Современный автопарк и&#160;корпоративное мобильное приложение для&#160;водителей',
      },
      {
        icon: homeIcon8,
        text: 'Средства индивидуальной защиты',
      },
      {
        icon: homeIcon12,
        text: 'Короткие маршруты в&#160;своем регионе',
      },
      {
        icon: homeIcon7,
        text: 'Бонусы для&#160;семьи и&#160;детские новогодние подарки',
      },
    ],
    startText: {
      title:
        'Привет! Меня зовут Георгий, я&#160;работаю водителем бензовоза в&#160;компании «Газпром нефть».',
      text: 'Я&#160;родился в&#160;небольшом городе и&#160;всегда мечтал путешествовать: летние поездки на&#160;море в&#160;семейном авто были для&#160;меня самым долгожданным приключением! Впервые сев за&#160;руль, я&#160;сразу понял, какую профессию выберу, когда вырасту.',
    },
    questions: {
      1: {
        question:
          'Чтобы рейс был безопасным, <span>перед выездом обязательно...</span>',
        extra:
          'Несколько лет я&#160;работал дальнобойщиком, но, когда появилась семья, стал понимать, что теперь нужна более спокойная и&#160;стабильная работа. В&#160;«Газпром нефти» меня устраивает всё: отличные условия, сплоченный коллектив и&#160;современный автопарк&#160;— управлять новыми и&#160;хорошо оснащенными тягачами не&#160;только престижно, но&#160;и&#160;приятно.',
        answers: [
          {
            answer: 'прохожу медицинское обследование',
            comment:
              'Перед выходом в&#160;рейс <span>каждый водитель проходит медицинскую комиссию</span>, ведь хорошее самочувствие&#160;– залог безопасности! А&#160;еще компания выдает в&#160;дорогу одежду по&#160;сезону и&#160;оформляет страховку.',
            extra: '',
          },
          {
            answer:
              'команда автомехаников проверяет техническое состояние бензовоза',
            comment:
              'За&#160;исправность транспортного средства, его ремонт и&#160;диагностику отвечает не&#160;водитель, <span>а&#160;специальная команда</span>. Они проверяют тягач перед выходом в&#160;рейс, а&#160;если возникнет непредвиденная поломка в&#160;дороге&#160;– всегда на&#160;связи диспетчер. Он&#160;оперативно организует выезд ремонтной бригады и&#160;сориентирует, где можно отдохнуть и&#160;перекусить.',
            extra: '',
          },
        ],
      },
      2: {
        question:
          'Как вы&#160;думаете, какие <span>корпоративные привилегии</span> еще есть у&#160;водителя бензовоза в&#160;«Газпром нефти»?',
        extra:
          'Я&#160;люблю свою работу и&#160;ощущение дороги, но&#160;также я&#160;понял, что&#160;не&#160;хочу больше уезжать в&#160;рейс на&#160;несколько месяцев. Ведь дома меня ждет семья. Поэтому я&#160;очень рад, что в&#160;«Газпром нефти» у&#160;меня короткие и&#160;понятные маршруты. Я&#160;занимаюсь любимым делом и&#160;успеваю домой к&#160;ужину.',
        answers: [
          {
            answer: 'ДМС со&#160;стоматологией',
            comment:
              'Возможность обслуживаться в&#160;лучших клиниках за&#160;счет компании, ДМС с&#160;широкой линейкой дополнительных услуг, в&#160;том числе и&#160;стоматологией, предоставляются сотрудникам сразу после трудоустройства.',
            extra: '',
          },
          {
            answer: 'семейные бонусы',
            comment:
              'Подарки на&#160;Новый год, компенсация путевки в&#160;детский оздоровительный лагерь, оплата проезда к&#160;месту отдыха и&#160;обратно, материальная помощь в&#160;связи с&#160;рождением ребенка: эти и&#160;другие бонусы для&#160;семьи уже доступны для&#160;всех сотрудников «Газпром нефти»!',
            extra: '',
          },
          {
            answer: 'корпоративный спорт',
            comment:
              'Спорт в&#160;жизни компании занимает важное место: у&#160;нас есть спортивные команды по&#160;футболу, волейболу и&#160;баскетболу, секции по&#160;плаванию, боксу и&#160;бегу.',
            extra: '',
          },
          {
            answer: 'горячее питание для&#160;сотрудников',
            comment:
              'На&#160;более 1500&#160;АЗС «Газпромнефть» сотрудникам предоставляются скидки на&#160;продукцию АЗС, а&#160;также на&#160;все производственные площадки организована доставка горячего питания. Я&#160;точно знаю, что в&#160;дороге всегда будет, где перекусить, полноценно пообедать или&#160;комфортно отдохнуть.',
            extra: '',
          },
        ],
      },
      3: {
        question:
          'Каждый водитель понимает важность и&#160;ответственность своей работы. Чтобы поддерживать хорошее самочувствие и&#160;нужный уровень концентрации, компания помогает мне соблюдать баланс работы и&#160;отдыха. У&#160;меня гибкий график, <span>благодаря которому есть возможность...</span>',
        extra: '',
        answers: [
          {
            answer:
              'полноценно отдохнуть, выспаться, провести время с&#160;родными',
            comment:
              'У&#160;каждого водителя есть надежный напарник, который работает на&#160;бензовозе, пока коллега на&#160;отдыхе, а&#160;это&#160;значит, что никто другой не&#160;сядет в&#160;машину. Мой бензовоз&#160;– моя крепость!',
            extra: '',
          },
          {
            answer:
              'спланировать отдых, поездку в&#160;отпуск или&#160;дорогие покупки',
            comment:
              'Прозрачная зарплата и&#160;понятная система премирования дают уверенность в&#160;завтрашнем дне и&#160;помогают строить планы на&#160;будущее.',
            extra: '',
          },
        ],
      },
      4: {
        question:
          'Тягач с&#160;автоцистерной весит несколько десятков тонн, поэтому в&#160;нашей работе очень важна безопасность. Все водители «Газпром нефти» проходят обучение в&#160;школе безопасного вождения и&#160;<span>знают, насколько важно...</span>',
        extra: '',
        answers: [
          {
            answer:
              'сосредоточиться на&#160;дороге и&#160;соблюдать правила дорожного движения',
            comment:
              'Рабочие процессы выстроены так, чтобы водитель не&#160;отвлекался от&#160;главного&#160;– <span>безопасного вождения</span>. План на&#160;день и&#160;детали поездки всегда перед глазами&#160;– в&#160;специальном мобильном приложении, которое компания разработала для&#160;водителей.',
            extra: '',
          },
          {
            answer: 'соблюдать скоростной режим и&#160;рекомендации диспетчера',
            comment:
              'Во&#160;время рейса нет нужды в&#160;спешке: сроки рассчитаны комфортно, чтобы водитель успел не&#160;только выполнить работу, но&#160;и&#160;отдохнуть. В&#160;мобильном приложении для&#160;водителей отображается текущее местоположение, расстояние до&#160;цели, соблюдение режима труда и&#160;отдыха&#160;– <span>всё для&#160;нашего удобства.</span>',
            extra: '',
          },
        ],
      },
      5: {
        question:
          'Больше всего на&#160;конкурсе мне <span>понравилось...</span>',
        extra:
          'Однажды коллеги по&#160;транспортному участку убедили меня попробовать свои силы на&#160;конкурсе профессионального мастерства. Финал проходил в&#160;Санкт-Петербурге, куда съехались водители-суперпрофессионалы со&#160;всей России и&#160;стран&#160;СНГ. Быть причастным к&#160;команде таких талантливых ребят мотивирует: есть куда стремиться и&#160;над&#160;чем&#160;работать!',
        answers: [
          {
            answer: 'соревноваться в&#160;искусстве вождения',
            comment:
              'Продемонстрировать навыки экстренного торможения и&#160;не&#160;сбить препятствие, провести бензовоз задним ходом или&#160;змейкой между фишками – у&#160;нас множество виртуозных навыков!',
            extra: '',
          },
          {
            answer: 'наблюдать за&#160;достижениями коллег',
            comment:
              'Конкурс профессионального мастерства «Газпром нефти»&#160;– прекрасная возможность и&#160;на&#160;других посмотреть, и&#160;себя показать! Победители получают ценные подарки и&#160;попадают в&#160;кадровый резерв компании.',
            extra: '',
          },
        ],
      },
    },
    finalText:
      'Я&#160;горжусь своей работой, ведь миллионы автомобилей на&#160;дорогах ежедневно едут на&#160;топливе, которое я&#160;вовремя доставляю на&#160;АЗС! <span>А&#160;вы хотите работать в&#160;«Газпром нефти»?</span>',
  },
  lab: {
    id: 'lab',
    title: 'Лаборант химанализа',
    image: hero3,
    homeSlideText: [
      'Каждый день я&#160;слежу за&#160;качеством нефтепродуктов: это очень интересная и&#160;ответственная работа. Я&#160;беру пробы из&#160;резервуаров, проверяю&#160;их на&#160;оборудовании, делаю расчеты за&#160;компьютером&#160;– никакая рутина не&#160;страшна!',
      'Компания дает мне возможности для&#160;роста: я&#160;участвую в&#160;интересных проектах, развиваю навыки управления, посещаю семинары по&#160;изучению новых технологий анализа. <span>Благодаря моей работе достойное качество топлива на&#160;АЗС всегда под&#160;контролем.</span>',
    ],
    homeSlideHidden: [
      {
        icon: homeIcon1,
        text: 'Интересная работа на&#160;современном лабораторном оборудовании',
      },
      {
        icon: homeIcon6,
        text: 'Расширенный пакет ДМС',
      },
      {
        icon: homeIcon4,
        text: 'Стабильная зарплата и&#160;премии по&#160;результатам работы',
      },
      {
        icon: homeIcon10,
        text: 'Горячее питание для&#160;сотрудников',
      },
      {
        icon: homeIcon2,
        text: 'Обучение за&#160;счет компании',
      },
      {
        icon: homeIcon11,
        text: 'Развозка на&#160;удаленные объекты',
      },
      {
        icon: homeIcon3,
        text: 'Удобный график',
      },
      {
        icon: homeIcon7,
        text: 'Бонусы для&#160;семьи и&#160;детские новогодние подарки',
      },
    ],
    startText: {
      title:
        'Здравствуйте! Я&#160;– Ирина. Совсем недавно я&#160;окончила колледж с&#160;дипломом химика-технолога, а&#160;выпускникам непросто найти работу.',
      text: 'Переезжать из&#160;небольшого города, в&#160;котором я&#160;прожила всю жизнь, мне не&#160;хотелось, но&#160;я&#160;мечтала найти работу по&#160;специальности. Мечта сбылась, когда меня взяли на&#160;стажировку в&#160;лабораторию «Газпром нефти», а&#160;после&#160;– предложили позицию лаборанта химического анализа.',
    },
    questions: {
      1: {
        question:
          'Впервые попав в&#160;испытательную лабораторию на&#160;нефтебазе, я&#160;была удивлена, насколько мощное и&#160;современное оборудование здесь используется. Но&#160;быстро стало понятно&#160;– иначе нельзя, ведь контроль должен быть на&#160;высшем уровне! <span>В&#160;моей работе меня привлекает...</span>',
        extra: '',
        answers: [
          {
            answer: 'разнообразие технических средств и&#160;методов',
            comment:
              'Работа лаборанта динамична и&#160;многопланова, хочется глубже погружаться в&#160;процессы и&#160;узнавать больше. Это помогает не&#160;останавливаться на&#160;достигнутом и&#160;продолжать развиваться личностно и&#160;профессионально.',
            extra: '',
          },
          {
            answer: 'возможность проявить профессиональные навыки',
            comment:
              'Особенности работы лаборанта развивают аналитическое мышление, умение концентрироваться, самоорганизованность. Точно и&#160;своевременно выполнять работу очень важно, потому что я&#160;— главный эксперт в&#160;оценке качества продукции, которая попадает в&#160;баки автомобилей.',
            extra: '',
          },
        ],
      },
      2: {
        question: 'Этот опыт вдохновил меня...',
        extra:
          'Я&#160;каждый день получаю удовольствие от&#160;своей работы и&#160;знаю, что от&#160;меня многое зависит. Когда начальник лаборатории впервые делегировала мне свои обязанности на&#160;время её&#160;отпуска, я&#160;очень волновалась, но в&#160;итоге у&#160;меня получилось организовать команду и&#160;распределить задачи так, чтобы каждый мог внести свой вклад.',
        answers: [
          {
            answer:
              'продолжить обучение, чтобы попасть в&#160;кадровый резерв компании',
            comment:
              'Чтобы попасть в&#160;кадровый резерв, надо постараться. Пройти дополнительное обучение, предоставляемое компанией, заявить о&#160;себе в&#160;конкурсе профессионального мастерства, проявлять инициативу, генерировать новые идеи и&#160;быть готовым принять на&#160;себя ответственность.',
            extra: '',
          },
          {
            answer:
              'пройти курсы развития лидерства, чтобы в&#160;будущем самой стать руководителем лаборатории',
            comment:
              'В&#160;компании есть множество возможностей для&#160;повышения квалификации и&#160;личностного роста сотрудников: от&#160;онлайн-семинаров и&#160;персональных тренингов до&#160;курсов психологической устойчивости и&#160;деловых игр.',
            extra: '',
          },
        ],
      },
      3: {
        question:
          'Мы&#160;работаем на&#160;опасном производстве, однако все мои коллеги и&#160;я&#160;чётко соблюдаем правила и&#160;уверены в&#160;своей безопасности. <span>Что&#160;мне&#160;нужно делать, чтобы моя работа была безопасной?</span>',
        extra: '',
        answers: [
          {
            answer: 'использовать средства индивидуальной защиты',
            comment:
              'Компания предоставляет всё необходимое для&#160;работы в&#160;лаборатории: комплект спецодежды, очки, перчатки, респиратор. А&#160;также регулярно проводит обязательное обучение по&#160;охране труда и&#160;производственной безопасности.',
            extra: '',
          },
          {
            answer:
              'следить за&#160;оборудованием и&#160;условиями окружающей среды',
            comment:
              'В&#160;лаборатории должна соблюдаться определенная температура, влажность и&#160;давление&#160;— это важно для&#160;правильной работы приборов. Поэтому компания регулярно обучает сотрудников выявлять и&#160;устранять потенциально опасные факторы, осуществляет техническое обслуживание и&#160;проверку оборудования на&#160;соответствие требованиям безопасности.',
            extra: '',
          },
        ],
      },
      4: {
        question:
          'Как вы&#160;думаете, какие еще условия нам предоставляет компания?',
        extra:
          'Топливный терминал с&#160;лабораторией находится за&#160;городом, но&#160;нас возит на&#160;работу и&#160;обратно корпоративный транспорт. Поэтому я&#160;никогда не&#160;опаздываю и&#160;в&#160;дороге могу почитать книгу. На&#160;нашей нефтебазе есть комнаты отдыха и&#160;приема пищи. Я&#160;редко беру еду с&#160;собой, потому что каждый день нам доставляют бесплатные горячие обеды.',
        answers: [
          {
            answer: 'ДМС со&#160;стоматологией',
            comment:
              'Возможность обслуживаться в&#160;лучших клиниках за&#160;счет компании, ДМС с&#160;широкой линейкой дополнительных услуг, в&#160;том числе и&#160;стоматологией, предоставляются сотрудникам сразу после трудоустройства.',
            extra: '',
          },
          {
            answer: 'семейные бонусы',
            comment:
              'Подарки на&#160;Новый год, компенсация путевки в&#160;детский оздоровительный лагерь, санаторно-курортное лечение: эти и&#160;другие бонусы для&#160;семьи уже доступны для&#160;всех сотрудников «Газпром нефти»!',
            extra: '',
          },
          {
            answer: 'корпоративный спорт',
            comment:
              'Спорт в&#160;жизни компании занимает важное место: у&#160;нас есть спортивные команды по&#160;футболу, волейболу и&#160;баскетболу, секции по&#160;плаванию, боксу и&#160;бегу, скидки на&#160;фитнес и&#160;бассейн.',
            extra: '',
          },
          {
            answer: 'мобильные медицинские обследования',
            comment:
              '«Газпром нефть» комплексно подходит к&#160;заботе о&#160;здоровье сотрудников: в&#160;компании регулярно проводятся медицинские обследования и&#160;углубленные чекапы, а&#160;социальный пакет работников включает обязательную страховку от&#160;несчастных случаев и&#160;болезней.',
            extra: '',
          },
          {
            answer: 'корпоративные мероприятия',
            comment:
              'В&#160;компании проводится множество мероприятий: от&#160;корпоративных конкурсов и&#160;сезонных праздников до&#160;спортивных состязаний и&#160;тематических акций.',
            extra: '',
          },
        ],
      },
      5: {
        question:
          'В&#160;прошлом году я&#160;приняла участие в&#160;конкурсе профессионального мастерства и&#160;заняла первое место в&#160;своей номинации! <span>Благодаря&#160;этой победе я...</span>',
        extra:
          'Могу сказать, что сделала отличный выбор, когда пришла работать в&#160;«Газпром нефть»! Благодаря стабильной зарплате и&#160;дополнительным бонусам от&#160;компании я&#160;могу и&#160;люблю путешествовать по&#160;разным странам и&#160;даже задумываюсь об&#160;ипотеке. Если вы&#160;показываете хорошие результаты, повышаете свой профессионализм и&#160;развиваетесь, компания это обязательно отмечает.',
        answers: [
          {
            answer: 'получила хороший денежный приз',
            comment:
              '<span>Материальный бонус</span>&#160;– это очень приятно! Но&#160;для&#160;меня более значимым стало&#160;то, что несколько тысяч сотрудников компании высоко оценили мой профессионализм и&#160;компетентность, а&#160;руководитель пригласил в&#160;новый проект!',
            extra: '',
          },
          {
            answer: 'была включена в&#160;кадровый резерв компании',
            comment:
              'Успех в&#160;конкурсе такого уровня&#160;– это весомый аргумент при&#160;рассмотрении кандидатуры сотрудника на&#160;более ответственные позиции. А&#160;пока я&#160;бы&#160;хотела стать наставником для&#160;молодых специалистов или&#160;куратором студентов, которые, как я&#160;<nobr>когда-то</nobr>, приходят на&#160;стажировку в&#160;компанию.',
            extra: '',
          },
        ],
      },
      6: {
        question:
          'Моя работа не&#160;только интересная, но&#160;и&#160;дает мне неожиданные возможности. Однажды я&#160;стала членом экипажа мобильной испытательной лаборатории, которая работала на&#160;выезде на&#160;Российской серии кольцевых гонок. Я&#160;увидела знаменитых гонщиков и&#160;ощутила азарт борьбы на&#160;трассе&#160;– это было&#160;незабываемо. <span>А&#160;еще я&#160;поняла одну важную вещь...</span>',
        extra: '',
        answers: [
          {
            answer: 'от&#160;моей работы зависит результат&#160;гонки',
            comment:
              'Лаборант контролирует качество топлива, которым заправляется российский автоспорт: и&#160;экстремальный, и&#160;кольцевой. Я&#160;горжусь, что работаю с&#160;продуктом высокого качества.',
            extra: '',
          },
          {
            answer: 'качество топлива&#160;– залог долгой службы автомобиля',
            comment:
              'Это правда, при&#160;плохом топливе износ двигателя происходит быстрее. Можно сказать, что я&#160;каждый день помогаю миллионам автомобилистов поддерживать их&#160;транспорт в&#160;порядке.',
            extra: '',
          },
        ],
      },
    },
    finalText:
      '<span>А&#160;вы&#160;бы&#160;хотели работать в&#160;«Газпром нефти»?</span>',
  },
  filler: {
    id: 'filler',
    title: 'Наполнитель баллонов',
    image: hero4,
    homeSlideText: [
      'Я&#160;работаю наполнителем баллонов на&#160;АЗС&#160;– заправляю сжиженным газом автомобили, резервуары и&#160;хозяйственные баллоны.',
      'Мне нравится моя понятная и&#160;четкая работа. А&#160;еще я&#160;много общаюсь с&#160;автомобилистами, своими постоянными клиентами: к&#160;нам приезжают со&#160;всего региона, с&#160;некоторыми знакомы уже&#160;много&#160;лет.',
      'В&#160;моей профессии очень важно соблюдать стандарты безопасности. Но&#160;также важно быть открытым, любить общаться и&#160;помогать людям: объяснять&#160;им, как&#160;правильно пользоваться газовым оборудованием и&#160;в&#160;автомобилях, и&#160;в&#160;загородных домах.',
    ],
    homeSlideHidden: [
      {
        icon: homeIcon1,
        text: 'Стабильная работа в&#160;крупной компании',
      },
      {
        icon: homeIcon6,
        text: 'Расширенный пакет ДМС и&#160;спорт',
      },
      {
        icon: homeIcon4,
        text: 'Стабильная зарплата и&#160;премии по&#160;результатам работы',
      },
      {
        icon: homeIcon9,
        text: 'Скидка на&#160;питание на&#160;АЗС',
      },
      {
        icon: homeIcon11,
        text: 'Развозка на&#160;удаленные объекты',
      },
      {
        icon: homeIcon3,
        text: 'Удобный график работы',
      },
      {
        icon: homeIcon8,
        text: 'Форма и&#160;средства индивидуальной защиты',
      },
      {
        icon: homeIcon7,
        text: 'Бонусы для&#160;семьи и&#160;детские новогодние подарки',
      },
    ],
    startText: {
      title:
        'Здравствуйте! Меня зовут Алексей. Я&#160;работаю на&#160;МАЗС&#160;– специальной модульной станции, где автомобили заправляют не&#160;только бензином или&#160;дизелем, но&#160;и&#160;газом. Моя профессия&#160;– наполнитель баллонов.',
      text: '',
    },
    questions: {
      1: {
        question: 'Моя задача в&#160;этом случае...',
        extra:
          'Наша АЗС расположена на&#160;оживленной трассе, поэтому клиентов много: и&#160;автомобили на&#160;газовом топливе, и&#160;дачники с&#160;баллонами. У&#160;меня уже есть постоянные клиенты, которые заправляются каждую неделю, а&#160;есть&#160;те, кто совсем недавно купил машину на&#160;газу или&#160;установил газовый баллон в&#160;доме, и&#160;еще толком не&#160;освоил тонкости работы оборудования.',
        answers: [
          {
            answer: 'объяснить правила использования газовых баллонов',
            comment:
              '<span>Верно!</span> Водителям, особенно новичкам, важно объяснить, на&#160;что обращать внимание при&#160;заправке автомобиля газом, как правильно подготовить баллон к&#160;наполнению и&#160;какие меры предосторожности соблюдать, ведь от&#160;этого может зависеть жизнь человека.',
            extra: '',
          },
          {
            answer: 'рассказать о&#160;мерах безопасности',
            comment:
              '<span>Верно!</span> Техника безопасности&#160;— большая часть работы наполнителя газовых баллонов. Важно не&#160;только самому соблюдать инструкции, но&#160;и&#160;научить клиентов основам безопасной эксплуатации. А&#160;тем, у&#160;кого газовый баллон установлен в&#160;доме, рассказать про&#160;правила его&#160;хранения и&#160;использования.',
            extra: '',
          },
        ],
      },
      2: {
        question:
          'Как вы&#160;думаете, что еще я&#160;ценю в&#160;своей работе?',
        extra:
          'У&#160;меня удобный сменный график&#160;– так я&#160;успеваю хорошо отдохнуть и&#160;провести время с&#160;семьей. А&#160;еще занимаюсь плаванием и&#160;хожу в&#160;спортзал&#160;– компания предоставляет сотрудникам скидки на&#160;фитнес и&#160;бассейн.',
        answers: [
          {
            answer: 'ДМС со&#160;стоматологией',
            comment:
              'Возможность обслуживаться в&#160;лучших клиниках за&#160;счет компании, ДМС с&#160;широкой линейкой дополнительных услуг, в&#160;том числе и&#160;стоматологией, предоставляются сотрудникам сразу после трудоустройства.',
            extra: '',
          },
          {
            answer: 'семейные бонусы',
            comment:
              'Подарки на&#160;Новый год, компенсация путевки в&#160;детский оздоровительный лагерь, материальная помощь в&#160;связи с&#160;рождением ребенка: эти и&#160;другие бонусы для&#160;семьи уже доступны для&#160;всех сотрудников «Газпром нефти»!',
            extra: '',
          },
          {
            answer: 'мобильные медицинские обследования',
            comment:
              '«Газпром нефть» комплексно подходит к&#160;заботе о&#160;здоровье сотрудников: в&#160;компании регулярно проводятся медицинские обследования и&#160;углубленные чекапы, а&#160;социальный пакет работников включает обязательную страховку от&#160;несчастных случаев и&#160;болезней.',
            extra: '',
          },
          {
            answer: 'частичная компенсация питания',
            comment:
              'На&#160;более 1500&#160;АЗС «Газпромнефть» сотрудникам предоставляются <span>скидки</span> на&#160;всю продукцию кафе.',
            extra: '',
          },
          {
            answer: 'корпоративный транспорт',
            comment:
              'Если место работы расположено вдали от&#160;города, сотрудники доставляются на&#160;работу и&#160;обратно на&#160;специальном транспорте за&#160;счет компании.',
            extra: '',
          },
        ],
      },
      3: {
        question:
          'На&#160;работе мне не&#160;приходится заботиться о&#160;том, что&#160;надеть, потому&#160;что нам выдают сезонные комплекты спецодежды и&#160;средства индивидуальной защиты. <span>Угадайте, с&#160;чего я&#160;начинаю рабочий день?</span>',
        extra: '',
        answers: [
          {
            answer: 'надеваю СИЗы',
            comment:
              '<span>Верно!</span> Средства индивидуальной защиты для&#160;каждого сотрудника&#160;– это важная часть обеспечения безопасности, они&#160;уменьшают риск получения производственных травм.',
            extra: '',
          },
          {
            answer: 'проверяю оборудование',
            comment:
              '<span>Правильно!</span> В&#160;работе с&#160;газом нет мелочей! Целостность и&#160;корректная работа оборудования&#160;– залог безопасности на&#160;рабочем месте.',
            extra: '',
          },
        ],
      },
      4: {
        question:
          'Пока женщина звонила в&#160;спецслужбу и&#160;паниковала, мы&#160;с&#160;коллегами помогли открыть дверь&#160;– ребенок даже не&#160;успел проснуться! <span>Где я&#160;получил такие полезные навыки?</span>',
        extra:
          'Во&#160;время работы всякое может произойти: нужно быть готовым быстро реагировать на&#160;непредвиденные ситуации или&#160;оказать первую помощь. Недавно произошел такой случай: молодая мама на&#160;заправке забыла вынуть ключ из&#160;замка зажигания, двери заблокировались, а&#160;в&#160;машине остался спящий малыш.',
        answers: [
          {
            answer: 'на&#160;специальных образовательных курсах',
            comment:
              '«Газпром нефть» обучает&#160;нас работать со&#160;сложными и&#160;нестандартными ситуациями на&#160;АЗС, управлять конфликтами, а&#160;также выстраивать хорошие отношения с&#160;клиентами.',
            extra: '',
          },
          {
            answer: 'на&#160;корпоративных курсах профессиональной подготовки',
            comment:
              'У&#160;меня есть удостоверение о&#160;профессиональной подготовке, которое подтверждает мою квалификацию. Техника безопасности и&#160;готовность к&#160;внештатным ситуациям&#160;– часть моей работы.',
            extra: '',
          },
        ],
      },
      5: {
        question:
          'У&#160;нас на&#160;АЗС дружная команда: хоть я&#160;работаю на&#160;улице, а&#160;операторы в&#160;помещении, мы&#160;много общаемся. <span>Почему в&#160;моей профессии важны хорошие навыки общения с&#160;людьми?</span>',
        extra: '',
        answers: [
          {
            answer: 'для&#160;обслуживания клиентов',
            comment:
              'У&#160;клиентов часто возникают вопросы о&#160;процессе наполнения, свойствах газа или&#160;правилах безопасности. Благодаря профессиональным знаниям и&#160;умению общаться я&#160;не&#160;только помогаю клиентам разобраться, но&#160;и&#160;делаю так, чтобы они&#160;возвращались к&#160;нам снова и&#160;снова.',
            extra: '',
          },
          {
            answer: 'для&#160;работы в&#160;команде',
            comment:
              'На&#160;АЗС мы&#160;все как&#160;семья. У&#160;каждого своя зона ответственности, но&#160;в&#160;трудных ситуациях вместе помогаем друг другу. Главное&#160;– сохранять улыбку на&#160;лице и&#160;не&#160;забывать пожелать хорошего пути.',
            extra: '',
          },
        ],
      },
    },
    finalText:
      '<span>А&#160;вы&#160;бы&#160;хотели работать в&#160;«Газпром нефти»?</span>',
  },
};
